import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const employeeTypeTaggingService = {
  getPreview: async (filterPayload) => {
    return await axios.post(`${domain}/api/EmployeeTypeTagging/preview`, { filters: filterPayload }, { headers });
  },
  create: async (payload) => {
    return await axios.post(`${domain}/api/EmployeeTypeTagging`, payload, { headers });
  }
};